import React, { useState } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { toast } from "sonner";

export default function Login() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const { login } = useAuth();
  const nav = useNavigate();
  const loc = useLocation();

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await login(email, password);
      toast.success("Welcome back.");
      const dest = loc.state?.from || "/dashboard";
      nav(dest);
    } catch (err) {
      toast.error(err?.response?.data?.detail || "Invalid credentials");
      setLoading(false);
    }
  };

  return (
    <div style={{ maxWidth: 440, margin: "80px auto", padding: "0 24px" }}>
      <div className="bg-card" style={{ padding: 36 }}>
        <div style={{ textAlign: "center", marginBottom: 28 }}>
          <div style={{ fontSize: 11, letterSpacing: "0.3em", color: "var(--gold)", marginBottom: 12 }}>OBITUARY RELIEF</div>
          <h1 className="serif" style={{ fontSize: 32, color: "#fff", margin: "0 0 8px", fontWeight: 400 }}>Welcome back</h1>
          <p className="muted" style={{ fontSize: 14 }}>Sign in to continue.</p>
        </div>
        <form onSubmit={submit}>
          <label className="label-dark">Email</label>
          <input data-testid="login-email" required type="email" value={email} onChange={e => setEmail(e.target.value)} className="input-dark" style={{ marginBottom: 16 }} placeholder="you@email.com" />
          <label className="label-dark">Password</label>
          <input data-testid="login-password" required type="password" value={password} onChange={e => setPassword(e.target.value)} className="input-dark" style={{ marginBottom: 8 }} placeholder="Your password" />
          <div style={{ textAlign: "right", marginBottom: 22 }}>
            <Link to="/forgot" data-testid="login-forgot-link" className="link-gold" style={{ fontSize: 13 }}>Forgot password?</Link>
          </div>
          <button data-testid="login-submit" type="submit" disabled={loading} className="btn-gold" style={{ width: "100%", padding: "14px" }}>
            {loading ? "Signing in…" : "Sign In"}
          </button>
        </form>
        <div style={{ marginTop: 22, textAlign: "center", fontSize: 14 }} className="muted">
          New here? <Link to="/signup" data-testid="login-link-signup" className="link-gold">Create an account</Link>
        </div>
      </div>
    </div>
  );
}
